<template>
    <div class="transfer-mutation-requests">

            <div class="row">
                <div class="col-12">
                    <mutation-overview
                        :mutationDeviceToken="this.deviceToken"
                        :sessionToken="this.session.session_token"
                        :mutationOverViewApi="this.baseUrl"
                        :showGroupFilter="true"
                        :filterEstablishment="selectedEstablishment.id"
                    />
                </div>
            </div>
    </div>
</template>

<script>
import MutationOverview from '@novict/mutation-overview';
import '@novict/mutation-overview/dist/mutation-overview.css';

export default {
    name: 'TransferMutationRequests',
    components: {
        MutationOverview
    },
    computed: {
        selectedEstablishment () {
            return this.$store.getters.selectedEstablishment
        },
    },
}
</script>
